import { customsAugmentationSettingsSchema } from "@redotech/redo-model/customs/customs-settings";
import * as z from "zod";

export const updateCustomsAugmentationSettings = {
  name: "updateCustomsAugmentationSettings" as const,
  input: customsAugmentationSettingsSchema,
  output: z.object({}),
};
